<div class="bpaas-layout-topbar">
  <p-toolbar>
    <div class="p-toolbar-group-left">
        <button pButton pRipple type="button" icon="pi pi-bars"
          class="p-button-rounded p-button-text" (click)="toggleSidebar()" id="btn-topbar-toggle-sidebar"></button>
        <a class="bpaas-layout-topbar-logo">
          <img src="../../../../assets/images/logo{{ layoutMain.mobileMode ? '-s' : '' }}.png" alt="logo">
          <span></span>
        </a>
        <p-badge *ngIf="isUat" class="bpaas-environment-label" size="large" severity="danger"
          value="{{ environmentLabel | translate }}"></p-badge>
    </div>

    <div class="p-toolbar-group-right">
      <div class="bpaas-toolbar-account" *ngIf="!layoutMain.mobileMode">{{ userDisplay }}</div>
      <button pButton pRipple type="button" icon="pi pi-user"
        class="p-button-rounded p-button-text" (click)="tUserMenu.toggle($event)" id="btn-topbar-user">
      </button>
      <p-menu #tUserMenu [popup]="true" [model]="userMenus" styleClass="bpaas-toolbar-menu-sticky"
        [style]="{'white-space': 'nowrap', 'width': 'auto'}"></p-menu>

      <button pButton pRipple type="button" icon="pi pi-globe"
        class="p-button-rounded p-button-text" (click)="tLanguageMenu.toggle($event)" id="btn-topbar-languages"></button>
      <p-menu #tLanguageMenu [popup]="true" [model]="languages" styleClass="bpaas-toolbar-menu-sticky"></p-menu>
    </div>
  </p-toolbar>
</div>

